<template>
  <div style="display: flex; flex-flow: row; align-items: center" class="py-8">
    <slot name="b-btn" />
    <h1
      class="adaprimary--text font-weight-bold py-4"
      id="coolxmashat"
      v-html="title"
    />
    <v-spacer />
    <v-btn v-if="!isP" @click="d" class="mx-2" rounded dark color="red">
      <v-icon dark>mdi-delete</v-icon>
    </v-btn>
    <v-btn v-if="!isP" to="canary" class="mx-2" rounded dark color="red">
      <v-icon dark>mdi-ab-testing</v-icon>
    </v-btn>
    <slot />
  </div>
</template>

<style scoped>
#coolxmashat {
  position: relative;
}
#coolxmashat::before {
  content: url("https://www.flaticon.com/svg/static/icons/svg/290/290414.svg");
  content: url("https://edu.kanakori.fi/img/hat.svg");
  filter: drop-shadow(-2px 2px 6px rgba(0, 0, 0, 0.7));
  position: absolute; /*or absolute*/
  z-index: 100000; /*a number that's more than the modal box*/
  left: -30px;
  top: -10px;
  height: 50px;
  width: 50px;
  transform: rotate(-25deg);
  transition: all ease-out 0.4s;
}
#coolxmashat:hover::before {
  left: -35px;
  top: -8px;
  transform: rotate(-40deg);
}
@media (max-width: 805px) {
  #coolxmashat::before,
  #coolxmashat:hover::before {
    filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.7));
    right: -30px;
    left: unset;
    top: -10px;
    transform: rotate(25deg);
  }
  #coolxmashat:hover::before {
    right: -35px;
    top: -8px;
    transform: rotate(40deg);
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "kanakori"
    }
  },
  methods: {
    d() {
      localStorage.removeItem("v5-save");
      localStorage.removeItem("userfirstname");
      location.reload();
    }
  },
  computed: {
    isP() {
      return process.env.NODE_ENV === "production";
    }
  }
};
</script>
